
import React, { useState } from 'react';
import { AutoComplete } from "primereact/autocomplete";
import { useNavigate } from "react-router-dom";
import { SERVER_HOST } from '../settings';

export default function GlobalSearch() {
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [filteredCountries, setFilteredCountries] = useState(null);

    const navigate = useNavigate();

    const search = async (event) => {
        fetch(`${SERVER_HOST}/users/search/${event.query.trim()}`)
            .then(data=>data.json())
            .then(data => setFilteredCountries(data));
    }

    const itemTemplate = (item) => {
        return (
            <div className="flex align-items-center">
                <img src={`/flags/${item?.countryCode?.toLowerCase()}.png`} style={{ width: '24px', marginRight: '0.5rem' }} />
                <div>{item?.nick}</div>
            </div>
        );
    };

    const onSelect = (e) => {
        navigate(`/player/${e.value.userId}`);
        setSelectedCountry('');
    }

    return (
        <div className="card flex justify-content-center">
            <AutoComplete placeholder='Search player' field="name" value={selectedCountry} suggestions={filteredCountries} completeMethod={search} itemTemplate={itemTemplate} onChange={(e) => { setSelectedCountry(e.value); }} onSelect={onSelect} inputStyle={{width: '9em'}} />
        </div>
    )
}
        